import { render, staticRenderFns } from "./bdEdit.vue?vue&type=template&id=fc0f7576"
import script from "./bdEdit.vue?vue&type=script&lang=js"
export * from "./bdEdit.vue?vue&type=script&lang=js"
import style0 from "./bdEdit.vue?vue&type=style&index=0&id=fc0f7576&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports